import { render, staticRenderFns } from "./ZimmerZuteilenModal.vue?vue&type=template&id=68bc8235"
import script from "./ZimmerZuteilenModal.vue?vue&type=script&lang=js"
export * from "./ZimmerZuteilenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports